import { Subject } from "rxjs"


export default (() => {
    const SUB = new Subject<{type: 'warning'|'confirm'|'error', message:string, clearTs?: number, id?:string, clickToClose?: boolean}>();
    return SUB;
})();